// External destinations for the two audiences.
export const BUSINESS_URL = "https://spot-filler-1.emergent.host";
export const CUSTOMER_URL = "https://lastminute-mobile.preview.emergentagent.com";

// Store links — sourced from env so Book Away can swap in the real URLs the
// moment the app is approved, no code change required. Fall back to the
// customer preview so smart-download flows keep working during the pre-launch
// phase.
export const APP_STORE_URL =
  process.env.REACT_APP_IOS_URL || CUSTOMER_URL;
export const PLAY_STORE_URL =
  process.env.REACT_APP_ANDROID_URL || CUSTOMER_URL;

export const goExternal = (url) =>
  window.open(url, "_blank", "noopener,noreferrer");

// Best-effort mobile OS detection. iPads on iPadOS 13+ masquerade as MacIntel
// with touch support, so check touch points too.
export function detectMobileOS() {
  if (typeof navigator === "undefined") return "other";
  const ua = navigator.userAgent || navigator.vendor || "";
  if (/android/i.test(ua)) return "android";
  if (/iPad|iPhone|iPod/.test(ua)) return "ios";
  if (
    navigator.platform === "MacIntel" &&
    typeof navigator.maxTouchPoints === "number" &&
    navigator.maxTouchPoints > 1
  ) {
    return "ios";
  }
  return "other";
}

// Custom event name broadcast on desktop clicks so the global
// <CustomerStoreDialog /> can open with both store badges.
export const CUSTOMER_STORE_EVENT = "bookaway:show-store-picker";

// Smart download link — sends iOS visitors straight to the App Store,
// Android to Google Play, and desktop visitors to a "Choose your store"
// dialog surfacing both storefronts.
export function goCustomer() {
  const os = detectMobileOS();
  if (os === "ios") return goExternal(APP_STORE_URL);
  if (os === "android") return goExternal(PLAY_STORE_URL);
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(CUSTOMER_STORE_EVENT));
  }
}
